import React from 'react';

import classes from './FlexRow.module.scss';

const flexRow = (props) => (
    <div className={[classes.FlexRow, props.className].join(' ')}>
        {props.children}
    </div>
);

export default flexRow;